require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./statewide-approach-to-mental-health-and-crisis-response.json") })
        }
      }, "path---statewide-approach-to-mental-health-and-crisis-response");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---statewide-approach-to-mental-health-and-crisis-response!./.cache/json/statewide-approach-to-mental-health-and-crisis-response.json
// module id = 987
// module chunks = 231608221292675